import { Box, Button, FormLabel, Typography } from "@mui/joy";
import React, { useRef, useState } from "react";
import { Dialog } from 'primereact/dialog';
import GenericTableView from "../../components/GenericTableView";
import { FilterMatchMode } from "primereact/api";
import { GenericTableColumTypes, GenericTableFilterTypes } from "../../enum/TableView";
import { MenuItem } from "primereact/menuitem";
import { GenericTableColumns } from "../../models/GenericTableViewModel";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { Toast } from 'primereact/toast';
import { dsfAdminRemove, dsfAdminUpdate } from "../../service/dsfAdminService";
import { RouteComponentProps } from "../../models/RouteComponent";
import { resetPassword } from "../../service/api-service";
import { Grid } from "@mui/material";
import { Chart } from "primereact/chart";



const data = {
  labels: ['Q1', 'Q2', 'Q3', 'Q4'],
  datasets: [
    {
      label: 'Sales',
      data: [540, 325, 702, 620],
      backgroundColor: [
        'rgba(255, 159, 64, 0.2)',
        'rgba(75, 192, 192, 0.2)',
        'rgba(54, 162, 235, 0.2)',
        'rgba(153, 102, 255, 0.2)'
      ],
      borderColor: [
        'rgb(255, 159, 64)',
        'rgb(75, 192, 192)',
        'rgb(54, 162, 235)',
        'rgb(153, 102, 255)'
      ],
      borderWidth: 1
    }
  ]
};
const options = {
  scales: {
    y: {
      beginAtZero: true
    }
  }
};

export default function ConsultantDashboard(props: RouteComponentProps) {

  const [selectedAdmin, setSelectedAdmin] = useState({} as any);
  const [visible, setVisible] = useState(false);
  const [reload, setReload] = useState(false);
  const toast = useRef(null as any);
  const dialog = useRef(null as any);

  const [chartData, setChartData] = useState(data);
  const [chartOptions, setChartOptions] = useState(options);



  return (
    <React.Fragment>
      <Box
        sx={{
          display: 'flex',
          mb: 1,
          gap: 1,
          flexDirection: { xs: 'column', sm: 'row' },
          alignItems: { xs: 'start', sm: 'center' },
          flexWrap: 'wrap',
          justifyContent: 'space-between',
        }}
      >
        <Typography level="h2" component="h1">
           Welcome to the Consultant Portal
        </Typography>

      </Box>

      <img src={require('../../assets/icon/animated_logo.gif')} style={{ width: '50%', margin: "auto" }} />

      <ConfirmDialog />

      <Toast ref={toast} />


    </React.Fragment>
  );
}